const palette = {
  mode: 'light',
  primary: {main: '#FA6400', light: '#FF9933', dark: '#E45C00', 50: '#FFFBF7', 100: '#F9E2CE', 700: '#C94E00', contrastText: '#FFFFFF' },
  secondary: {main: '#8464DB', 500: '#8464DB', contrastText: '#FFFFFF'},
  secondary2: {main: '#3D82ED', 500: '#3D82ED', contrastText: '#FFFFFF'},
  error: {100: '#FFEBEB', 500: '#EB0004', contrastText: '#FFFFFF'},
  grey: {main: '#6D7882', light: '#8A949E', dark: '#58616A', 0: '#FFFFFF', 50: '#F8F9FA', 100: '#EFF1F2', 300: '#8A949E', 500: '#6D7882', 600: '#58616A', 800: '#33363D', 900: '#1E2124', 1000: '#000000', contrastText: '#FFFFFF'},
  text: { primary: '#131416', secondary: '#464C53', contrastText: '#FFFFFF' },
  divider: '#DCE1E6',
};

export default palette;
